<template>
    <!--
        White continuation of the header panel holding the hero card: the red
        radial gradient with the diagonal product collage is a single flat
        export (desktop and mobile crops); the headline stays live text.
    -->
    <section class="relative bg-white px-4 pt-4 sm:px-9 sm:pt-[15px]">
        <!--
            The category band's navy rises up behind the hero card's lower
            portion (mock: the band rect starts 103px before the hero ends),
            so the card reads as floating across the white/navy seam.
        -->
        <div
            aria-hidden="true"
            class="absolute inset-x-0 bottom-0 bg-brand-navy max-md:hidden md:h-[103px]"
        ></div>

        <div
            class="relative h-[141px] overflow-hidden rounded-brand md:h-[259px]"
        >
            <img
                :src="asset('images/explore/hero-mobile.png')"
                alt=""
                aria-hidden="true"
                class="absolute inset-0 h-full w-full object-cover md:hidden"
            />
            <img
                :src="asset('images/explore/hero-desktop.png')"
                alt=""
                aria-hidden="true"
                class="absolute inset-0 h-full w-full object-cover max-md:hidden"
            />

            <h1
                class="absolute left-4 top-1/2 max-w-[50%] -translate-y-1/2 font-brand-display text-[24px] font-black italic uppercase leading-[0.95] tracking-[-0.02em] text-white md:left-12 md:text-[clamp(2.5rem,4.5vw,66px)]"
            >
                Gift ideas for everyone.
            </h1>
        </div>
    </section>
</template>
